import { useEffect, useState } from 'react'
import to from 'await-catch'
import { getPatientAppointments } from '../api'

const inFlightAppointmentsByPatientId = {}

export const useUpcomingAppointments = ({ patientId, addFlashMessage, limit = 4 }) => {
	const [todayAppointments, setTodayAppointments] = useState([])
	const [allUpcomingAppointments, setAllUpcomingAppointments] = useState([])
	const [upcomingAppointments, setUpcomingAppointments] = useState([])
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		if (!patientId) {
			setTodayAppointments([])
			setAllUpcomingAppointments([])
			setUpcomingAppointments([])
			setIsLoading(false)
			return
		}

		let isMounted = true
		setIsLoading(true)

		if (!inFlightAppointmentsByPatientId[patientId]) {
			inFlightAppointmentsByPatientId[patientId] = to(getPatientAppointments(patientId)).finally(
				() => {
					delete inFlightAppointmentsByPatientId[patientId]
				}
			)
		}

		const fetchAppointments = async () => {
			try {
				const [err, { data } = {}] = await inFlightAppointmentsByPatientId[patientId]
				if (err) {
					throw err
				}

				const appointmentsList = Array.isArray(data) ? data : data?.items || []
				const sorted = [...appointmentsList].sort(
					(a, b) => new Date(a.fechaTurnoDateTime) - new Date(b.fechaTurnoDateTime)
				)

				const now = new Date()
				const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)

				const today = []
				const upcoming = []

				sorted.forEach(app => {
					const date = new Date(app.fechaTurnoDateTime)
					if (date >= todayStart && date <= todayEnd) {
						today.push(app)
					} else if (date > todayEnd) {
						upcoming.push(app)
					}
				})

				const nextAppointments = upcoming.slice(0, limit)

				if (!isMounted) return
				setTodayAppointments(today)
				setAllUpcomingAppointments(upcoming)
				setUpcomingAppointments(nextAppointments)
			} catch (error) {
				if (!isMounted) return
				addFlashMessage('Ocurrió un error cargando los turnos')
			} finally {
				if (isMounted) setIsLoading(false)
			}
		}

		fetchAppointments()

		return () => {
			isMounted = false
		}
	}, [addFlashMessage, limit, patientId])

	return {
		todayAppointments,
		allUpcomingAppointments,
		upcomingAppointments,
		isLoading
	}
}